module.exports = __webpack_public_path__ + "img/team-2.9458f7cc.jpg";